import type { PokerGameTileAttribute } from '@ps/poker-games-tile-mappers';
import { AttributeKey, TournamentState } from '@ps/poker-games-tile-mappers';
import type { TranslationTag } from '@ps/web-shared-components';
import { useIntl } from 'react-intl';

import {
  TXTCLI_Cancelled,
  TXTCLI_Completed,
  TXTCLI_Late_Registration,
  TXTCLI_Running,
  TXTCLI_Running_for
} from './useGetTournamentState.messages.json';

interface TournStateTranslation {
  [key: string]: { text: TranslationTag | null; inheritValue: boolean; addColon?: boolean };
}

export const tournStateTranslations: TournStateTranslation = {
  [TournamentState.CANCELLED]: { text: TXTCLI_Cancelled, inheritValue: false },
  [TournamentState.COMPLETED]: { text: TXTCLI_Completed, inheritValue: false },
  [TournamentState.LATE_REGISTRATION]: {
    text: TXTCLI_Late_Registration,
    inheritValue: true,
    addColon: true
  },
  [TournamentState.ANNOUNCED]: { text: null, inheritValue: true },
  [TournamentState.RUNNING]: { text: TXTCLI_Running_for, inheritValue: true },
  [TournamentState.REGISTERING]: { text: null, inheritValue: true }
};

const getName = ({
  tournamentState
}: {
  tournamentState: TournamentState;
}): TranslationTag | null => {
  switch (tournamentState) {
    case TournamentState.LATE_REGISTRATION:
      return TXTCLI_Late_Registration;

    case TournamentState.RUNNING:
      return TXTCLI_Running;

    default:
      return null;
  }
};

export default (attributes: PokerGameTileAttribute[], tournamentState?: TournamentState) => {
  const { formatMessage } = useIntl();
  let [state] = attributes.filter(
    ({ key }) =>
      key === AttributeKey.startTime ||
      key === AttributeKey.startsIn ||
      key === AttributeKey.running ||
      key === AttributeKey.lateReg
  );

  if (tournamentState) {
    const object = tournStateTranslations[tournamentState];
    const value = state?.value;

    if (object) {
      const { inheritValue, text, addColon } = object;
      let name = text ? formatMessage(text) : '';

      if (addColon && value) {
        name = `${name}:`;
      }

      if (!value && inheritValue) {
        const translation = getName({ tournamentState });

        name = translation ? formatMessage(translation) : '';
      }

      state = { value: inheritValue && value ? value : '', key: tournamentState as never, name };
    }
  }

  return state;
};
